import React, { useEffect, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { getAllPhysician } from "../../../store/slices/physicianSlice";
import { getStateSlice } from "../../../store/slices/state";
import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";
import { getaccountType } from "../../../store/slices/accountType";
import { getBankListSlice } from "../../../store/slices/bankSlice";
import {
  createPharmaSalesRetailerSlice,
  updatePharmaSalesRetailerSlice,
  getAllPharmaSalesRetailerSlice,
  getPharmaSalesRetailerByIdSlice,
  resetUpdatePharmaSalesRetailerMessage,
  resetAddPharmaSalesRetailerMessage,
} from "../../../store/slices/pharmaSalesRetailerSlice";
import Table from "../../common/Table/table";
// import ViewPharmaSalesDetails from "./viewPharmaSalesDetails";
import { useNavigate } from "react-router-dom";
import AddUpdatePharmaSalesRetailer from "./addUpdatePharmaSalesRetailer";
import ViewPharmaRetailerInvoice from "./viewPharmaRetailerInvoice";

const PharmaSalesRetailer = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteSales, setDeleteSales] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [viewModal, setViewModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const initialState = {
    retailerName: "",
    retailerId: "",
    billDate: "",
    billId: "",
    billedBy: "",
    prescribedBy: "",
    placeOfSupply: "",
    placeOfSupplyName: "",
    items: [],
    totalAmount: "",
    discount: "",
    discountPercent: "",
    subTotal: "",
    medicineRows: [],
    accountType: "",
    accountTypeName: "",
    bank: "",
    bankName: "",
    paymentStatus: "UNPAID",
    receivedBy: "",
  };

  const [salesFormData, setSalesFormData] = useState(initialState);

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { paymentStatus } = useSelector((state) => state.tablePaidStatus);
  const navigate = useNavigate();
  const clinicId =clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      }),
    );
    dispatch(getStateSlice({ token }));
    dispatch(
      getAllStockSlice({
        clinicId,
        token,
      }),
    );
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(
      getBankListSlice({
        status: ["Active"],
        clinicId,
        token,
      }),
    );
  }, [dispatch, token, clinicId, showModal, setShowModal]);

  const { physician } = useSelector((state) => state.physician);
  const { state } = useSelector((state) => state.state);
  const { stockInventory } = useSelector((state) => state.stockInventory);
  const {
    pharmaSalesRetailer,
    createPharmaSalesRetailerSuccessMessage,
    createPharmaSalesRetailerErrorMessage,
    updatePharmaSalesRetailerSuccessMessage,
    updatePharmaSalesRetailerErrorMessage,
    searchPharmaSalesRetailerErrorMessage,
    totalCount,
    totalPages,
    currentPage,
    isLoading,
  } = useSelector((state) => state.pharmaSalesRetailer);
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);

  const [purchaseFormData, setPurchaseFormData] = useState(initialState);

  const [inputError, setInputError] = useState({
    supplier: false,
    invoiceId: false,
    invoiceDate: false,
  });

  const fetchPharmaSales = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllPharmaSalesRetailerSlice({
            clinicId,
            token,
            paymentStatus,
            currentPage: page,
            limit: lim,
            search: search || undefined,
            fromDate: reportFromData.fromDate || undefined,
            toDate: reportFromData.toDate || undefined,
          }),
        );
      }
    },
    [
      dispatch,
      clinicInfo,
      token,
      paymentStatus,
      pageLimit,
      searchValue,
      reportFromData.fromDate,
      reportFromData.toDate,
    ],
  );

  useEffect(() => {
    if (clinicId && token) {
      fetchPharmaSales(1, pageLimit, searchValue);
    }
  }, [
    clinicId,
    token,
    paymentStatus,
    pageLimit,
    searchValue,
    fetchPharmaSales,
  ]);
  const handlePageChange = (page) => {
    fetchPharmaSales(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchPharmaSales(1, newLimit, searchValue);
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      createPharmaSalesRetailerSuccessMessage,
      showToastifySuccess,
      resetAddPharmaSalesRetailerMessage,
    );
    showTostifyMessageAndReset(
      createPharmaSalesRetailerErrorMessage,
      showToastifyError,
      resetAddPharmaSalesRetailerMessage,
    );
    showTostifyMessageAndReset(
      updatePharmaSalesRetailerSuccessMessage,
      showToastifySuccess,
      resetUpdatePharmaSalesRetailerMessage,
    );
    showTostifyMessageAndReset(
      updatePharmaSalesRetailerErrorMessage,
      showToastifyError,
      resetUpdatePharmaSalesRetailerMessage,
    );
  }, [
    createPharmaSalesRetailerSuccessMessage,
    createPharmaSalesRetailerErrorMessage,
    updatePharmaSalesRetailerSuccessMessage,
    updatePharmaSalesRetailerErrorMessage,
    showTostifyMessageAndReset,
  ]);
  const [userInput, setUserInput] = useState({
    name: false,
    email: false,
    phone: false,
  });
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const handleSelectChange = (selectedOption, name) => {
    if (name === "retailer") {
      setSalesFormData({
        ...salesFormData,
        retailerId: selectedOption?.value,
        retailerName: selectedOption?.label,
      });
    } else if (name === "accountType") {
      setSalesFormData({
        ...salesFormData,
        accountType: selectedOption?.value,
        accountTypeName: selectedOption?.label,
        bank: "",
        bankName: "",
      });
    } else if (name === "bank") {
      setSalesFormData({
        ...salesFormData,
        bank: selectedOption?.value,
        bankName: selectedOption?.label,
      });
    }
  };

  const handlePlaceChange = (selectedOption, name) => {
    setSalesFormData({
      ...salesFormData,
      placeOfSupply: selectedOption?.value,
      placeOfSupplyName: selectedOption?.label,
    });
  };

  const setPaymentStatus = (value) => {
    setSalesFormData((prev) => ({
      ...prev,
      items: prev.items ?? [],
      paymentStatus: value,
    }));
  };

  const handleModal = (action, sales = null) => {
    if (action === "edit" || (action === "refund" && sales)) {
      setSalesFormData({
        salesId: sales?._id,
        retailerId: sales?.retailerId?._id,
        retailerName: sales?.retailerId?.name,
        invoiceId: sales?.invoiceId,
        invoiceDate: sales?.invoiceDate?.split("T")[0],
        prescribedBy: sales?.prescribedBy,
        placeOfSupply: sales?.placeOfSupply?._id,
        placeOfSupplyName: sales?.placeOfSupply?.name,
        subTotal: sales?.subTotal,
        items: sales?.item || [],
        paymentStatus: sales?.paymentStatus,
        isAlreadyPaid: sales?.paymentStatus === "PAID",
        accountType: sales?.accountType?._id,
        accountTypeName: sales?.accountType?.name,
        bank: sales?.bank?._id,
        bankName: sales?.bank?.name,
      });
    } else if (action === "create") {
      setSalesFormData({ ...initialState, isAlreadyPaid: false });
    }
    setShowModal(true);
    setModalAction(action);
  };
  const handleAddUpdate = async ({ medicineRows }) => {
    const subTotal = medicineRows.reduce(
      (sum, item) => sum + Number(item?.total || 0),
      0,
    );

    const salesPayload = {
      ...salesFormData,
      item: medicineRows,
      subTotal,
      clinicId,
      token,
      createdBy: userInfo?._id,
      billedBy: userInfo?._id,
      receivedBy:
        salesFormData?.paymentStatus === "PAID" ? userInfo?._id : null,
      paymentDate:
        salesFormData?.paymentStatus === "PAID" ? formattedDate : null,
      paidAmount: salesFormData?.paymentStatus === "PAID" ? subTotal : null,
      isAlreadyPaid: salesFormData?.paymentStatus === "PAID" ? true : false,
    };
    let response;
    if (modalAction === "edit" && salesPayload?.salesId) {
      response = await dispatch(
        updatePharmaSalesRetailerSlice({
          id: salesPayload?.salesId,
          paymentStatus: salesFormData?.paymentStatus,
          clinicId,
          token: token,
          bank: salesFormData?.bank,
          accountType: salesFormData?.accountType,
          paymentDate: salesFormData?.paymentStatus === "PAID" && formattedDate,
          paidAmount: salesFormData?.subTotal,
          receivedBy:
            salesFormData?.paymentStatus === "PAID" ? userInfo?._id : null,
          updatedBy: userInfo?._id,
        }),
      );
    } else {
      response = await dispatch(createPharmaSalesRetailerSlice(salesPayload));
    }
    if (response?.payload?.success) {
      dispatch(
        getAllPharmaSalesRetailerSlice({
          clinicId,
          token,
          paymentStatus: paymentStatus,
        }),
      );
      setSalesFormData(initialState);
      setShowModal(false);
    }
  };
  const tableHead = [
    { title: "Retailer Name", key: "retailerName" },
    { title: "Invoice Date", key: "invoiceDate" },
    { title: "Amount", key: "amount" },
    { title: "Status", key: "status" },
  ];

  const handleEdit = async (sales) => {
    try {
      const res = await dispatch(
        getPharmaSalesRetailerByIdSlice({ id: sales?.id, token }),
      );
      const salesData = res?.payload?.result?.list;
      setSalesFormData({
        salesId: salesData?._id,
        retailerId: salesData?.retailerId?._id,
        retailerName: salesData?.retailerId?.name,
        invoiceId: salesData?.billDate,
        invoiceDate: salesData?.invoiceDate?.split("T")[0],
        prescribedBy: salesData?.prescribedBy,
        placeOfSupply: salesData?.placeOfSupply?._id,
        placeOfSupplyName: salesData?.placeOfSupply?.name,
        subTotal: salesData?.subTotal,
        items: salesData?.item || [],
        paymentStatus: salesData?.paymentStatus,
        accountType: salesData?.accountType?._id,
        accountTypeName: salesData?.accountType?.name,
        bank: salesData?.bank?._id,
        bankName: salesData?.bank?.name,
      });
      handleModal("edit", salesData);
    } catch (error) {
      console.error("Failed to get Sales Data: Please Try Later..", error);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchPharmaSales(1, pageLimit, value);
  };

  const handleFilter = async () => {
    fetchPharmaSales(1, pageLimit, searchValue);
  };

  const handleClear = useCallback(() => {
    setReportFromData({ fromDate: "", toDate: "" });
    fetchPharmaSales(1, pageLimit, searchValue);
  }, [fetchPharmaSales, pageLimit, searchValue]);

  const handleShowGlobalViewModal = async (data) => {
    const res = await dispatch(
      getPharmaSalesRetailerByIdSlice({ id: data?.id, token }),
    );
    const salesData = res?.payload?.result?.list;
    setSalesFormData({
      salesId: salesData?._id,
      retailerId: salesData?.retailerId?._id,
      retailerName: salesData?.retailerId?.name,
      invoiceId: salesData?.billDate,
      invoiceDate: salesData?.invoiceDate?.split("T")[0],
      prescribedBy: salesData?.prescribedBy,
      placeOfSupply: salesData?.placeOfSupply?._id,
      placeOfSupplyName: salesData?.placeOfSupply?.name,
      subTotal: salesData?.subTotal,
      items: salesData?.item || [],
      paymentStatus: salesData?.paymentStatus,
      accountType: salesData?.accountType?._id,
      accountTypeName: salesData?.accountType?.name,
      bank: salesData?.bank?._id,
      bankName: salesData?.bank?.name,
    });
    setViewModal(true);
  };

  const PharmaRetailerMyCollection = (startDate, endDate, receivedBy) => {
    navigate(`/pharmaRetailerMyCollection`, {
      state: { startDate, endDate, receivedBy: userInfo?._id },
    });
  };
  const handlePrint = (salesId) => {
    navigate(`/viewPharmaRetailerInvoice`);
    sessionStorage.setItem("retailerSalesId", salesId.id);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>
        <div className="col-md-2 mt-4">
          <button
            className="btn btn-primary"
            onClick={() => PharmaRetailerMyCollection()}
          >
            My Collection
          </button>
        </div>
      </div>
      <>
        <div className="container mt-4">
          <Table
            tableHead={tableHead}
            tableBody={
              pharmaSalesRetailer &&
              pharmaSalesRetailer?.map((item) => ({
                id: item?._id,
                retailerName: item?.retailerId?.name || "N/A",
                invoiceDate: item?.billDate?.split("T")[0] || "N/A",
                amount: item?.subTotal?.toFixed(2) || "N/A",
                status: item?.paymentStatus || "N/A",
              }))
            }
            handleAddBtn={true}
            handleSearchOption={true}
            searchValue={searchValue}
            handleSearch={handleSearch}
            errorMessage={searchPharmaSalesRetailerErrorMessage}
            handleShowGlobalViewModal={handleShowGlobalViewModal}
            handleEdit={handleEdit}
            addModal={() => handleModal("create")}
            handleShare={false}
            showPaymentStatusTab={false}
            payemntHeaderColor="paymentTabcolor"
            handlePrint={handlePrint}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={pageLimit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            showPagination={true}
            showLimitDropdown={true}
            hideStatusTab={false}
            isLoading={isLoading}
          />

          <AddUpdatePharmaSalesRetailer
            showModal={showModal}
            setShowModal={setShowModal}
            handleAddUpdate={handleAddUpdate}
            salesFormData={salesFormData}
            setSalesFormData={setSalesFormData}
            handleSelectChange={handleSelectChange}
            handlePlaceChange={handlePlaceChange}
            physician={physician}
            modalAction={modalAction}
            setInputError={setInputError}
            userInput={userInput}
            state={state}
            medicines={stockInventory}
            accountType={accountType}
            bank={bank}
            setPaymentStatus={setPaymentStatus}
          />
          {/* <ViewPharmaSalesDetails
            show={viewModal}
            onHide={() => setViewModal(false)}
            salesData={salesFormData}
          /> */}
          <Modal
            centered
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Are You Sure Want to Cancel it?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              After Cancellation, you won't be able to recover the data
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => setDeleteModal(false)}
                className="p-2"
              >
                Back to Page
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    </>
  );
};

export default PharmaSalesRetailer;
